/* eslint-disable camelcase */
import React, { useContext, useEffect, useState } from 'react'
import InputSearch from '../../utils/controls/input-search'
import Buttons from '../../components/buttons/buttons'
import { PageHeader } from '../../layouts/header/page-header'
import PageOverlay from '../../pageoverLay/pageoverLay'
import Noresult from '../noresult/noresult'
import { formatDateandTime, formatTimestamp, highlightMatchingText, removehtmltags } from '../../Global'
import axios from 'axios'
import { decodeHTML } from '../../shared/utility'
import { useInfiniteScroll } from '../../shared/hooks/infiniteScroll'
import { useLocation } from 'react-router-dom'
import { AuthContext } from '../../shared/contexts/AuthContextProvider'
import { accestoken, BASE_URL } from '../../configuration'
export default function KnowledgeArticles () {

  const [knowlegeGraphItems, setKnowlegeGraphItems] = useState<any>([])
  const [knowlegeGraphItemsActive, setKnowlegeGraphItemsActive] = useState<any>([])
  const [searchQuery, setSearchQuery] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [inputValues, setInputValues] = useState<string>()
  const visibleRows = useInfiniteScroll('wrapper')
  const {loginUserRoles,loadingRoles,accessToken} = useContext(AuthContext)
  useEffect(() => {
    const fetchTopFaqs = async () => {
      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    }
        setLoading(true)
        try {
          const knowledgeResponse = await axios.get(`${BASE_URL}/knowledge_graphs`, { headers })
            setKnowlegeGraphItems(knowledgeResponse.data.top_faqs) 
            setKnowlegeGraphItemsActive(knowledgeResponse.data.top_faqs)
            setLoading(false)
        } catch (error:any) {
          console.error(error.message)
          setLoading(false)
        }
      }
      if (!loadingRoles) {
        fetchTopFaqs()
      }
  }, [loadingRoles])
  const redirecttoHome = () => {
    window.location.href = '#'
  }
  const inputValue = (e: any) => {
    if (e?.target?.value) {
      setInputValues(e.target.value)
      setSearchQuery(e.target.value)
     filterItems(e.target.value)
    } else {
      setInputValues('')
      setSearchQuery('')
     filterItems('')
    }
  }
  const changeSearchQuery = (e: any) => {
    setSearchQuery(inputValues)
  }
  const clearAll = (e: any) => {
    setSearchQuery('')
    setInputValues('')
    setKnowlegeGraphItems(knowlegeGraphItemsActive)
  }
//   useEffect(() => {
//     filterItems()
//   }, [searchQuery])
  const filterItems = (searchQueryVal : string) => {
    if (searchQueryVal !== '' && searchQueryVal) {
      const filtered = knowlegeGraphItems.filter((data : any) => {
        const Title = data?.title || ''
        const descriptionWithoutHTML = removehtmltags(decodeHTML(data?.description)) || ''
        const modifiedByTitle = data?.modifiedby || ''
        const formattedModified = formatTimestamp(data?.modifiedon) || ''
        const queryLowerCase = searchQueryVal.toLowerCase()

        return (
          Title?.toLowerCase().includes(queryLowerCase) ||
          descriptionWithoutHTML?.toLowerCase().includes(queryLowerCase) ||
          modifiedByTitle?.toLowerCase().includes(queryLowerCase) ||
          formattedModified?.toLowerCase().includes(queryLowerCase) 
        )
      })
      setKnowlegeGraphItems(filtered)
    } else {
      setKnowlegeGraphItems(knowlegeGraphItemsActive)
    }
  }
  return (
    <>
    {loading
      ? <PageOverlay />
      : <>
     <PageHeader name='Knowledge Articles' badgeClassName={'mt-2 p-1 font-13 px-2'} titleClass='font-24' count={knowlegeGraphItems?.length?.toString()?.padStart(1, '0')} icon="icon-knowledge-graph font-15 me-1 color-primary" 
                extras={<>
               <InputSearch
              inputProps={{
                placeholder: 'Search',
                value: searchQuery,
                className:'font-0 d-none'
              }}
              label="Search"
              className='no-border w-100 form-sm title-color51 sourcesanspro font-13'
              searchgroup=' w-100 d-flex align-items-center bordered inputswithicon '
              icon='icon-search pe-2 color-primary'
              onChange={(e: any) => inputValue(e)}
              onClick={(e: any) => changeSearchQuery(e)} />
          <Buttons
            label="Clear All"
            className='ms-auto btn-sm sourcesansprosemibold font-13 d-flex align-items-center links text-decoration-underline'
            type="button"
            onClick={(e: any) => clearAll(e)}
          />
          <Buttons
                label="BACK"
                aria-label="Back"
                icon="icon-rb-arrow-left-thick me-1 font-11"
                className='btn-sm font-14 btn-primary whitetext text-nowrap border-radius'
                onClick={(e: any) => redirecttoHome()}
              />
            </>}
            />
      <div className="container">
        <div className="mt-3">
          <div className="whitebg border-radius p-3 ">
            <div className="font-13 pe-1 no-border-last-child">
            {knowlegeGraphItems?.length > 0
              ? knowlegeGraphItems?.slice(0,visibleRows)?.map((knowledgearticles : any) =>
                <div key={knowledgearticles.id}><div className="mb-3">
                <a
                  href={knowledgearticles.path}
                  title={knowledgearticles.title}
                  className="m-0 color-primary poppins-semibold font13"
                  target="_blank"
                  rel="noopener noreferrer"
                  tabIndex={0} aria-label={knowledgearticles?.title}
                >
                  <span dangerouslySetInnerHTML={{ __html: highlightMatchingText(knowledgearticles?.title, searchQuery) }}></span>
                </a>
                  <p tabIndex={0} aria-label={knowledgearticles.Tags} className="m-0 sourcesanspro subtitle-color9 font-13 px-2 pt-2 chatbot">
                    <span dangerouslySetInnerHTML={{ __html: highlightMatchingText(knowledgearticles?.description, searchQuery)}}></span>
                  </p>
                  <p tabIndex={0} aria-label={knowledgearticles.Tags} className="m-0 sourcesanspro subtitle-color9 ps-2 font-13">
                   <span dangerouslySetInnerHTML={{ __html: highlightMatchingText(knowledgearticles?.modifiedby + ' | ' + formatTimestamp(knowledgearticles.modifiedon)||'', searchQuery)}}></span>
                  </p>
                </div><div className='border-bottom29 my-3'></div></div>
                )
              : <div className='min-h-200 d-flex align-items-center justify-content-around'>
            <Noresult />
          </div>}
            </div>
            {/* </InfiniteScroll> */}
          </div>
        </div>
      </div>
    </> }
    </>
  )
}
